import { render, staticRenderFns } from "./IconsGetter.vue?vue&type=template&id=3cc77dde&scoped=true"
import script from "./IconsGetter.vue?vue&type=script&lang=js"
export * from "./IconsGetter.vue?vue&type=script&lang=js"
import style0 from "./IconsGetter.vue?vue&type=style&index=0&id=3cc77dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc77dde",
  null
  
)

export default component.exports